// @flow @format
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'lib/classnames';
import {Link} from 'react-router';
import './FileListItem.css';

import type {Node} from 'react';

export const FileListItemRow = ({
	children,
	className = '',
}: {
	children?: Node,
	className?: string,
}) =>
	<div className={classNames('FileList__Item__Row', className)}>
		{children}
	</div>;

FileListItemRow.propTypes = {
	children: PropTypes.any.isRequired,
	className: PropTypes.string,
};

export const FileListItemCol = ({
	children,
	className = '',
}: {
	children?: Node,
	className?: string,
}) =>
	<div className={classNames('FileList__Item__Col', className)}>
		{children}
	</div>;

FileListItemCol.propTypes = {
	children: PropTypes.any.isRequired,
	className: PropTypes.string,
};

FileListItemCol.defaultProps = {
	className: '',
};

export const FileListItemLink = (props: {
	to: string,
	children?: Node,
	className?: string,
}) =>
	<Link
		className={classNames('FileList__Item__Link', props.className || '')}
		to={props.to}
	>
		{props.children}
	</Link>;

export const FileListItemOptions = ({children}: {children?: Node}) =>
	<div className="FileList__Item__Options">
		{children}
	</div>;

FileListItemOptions.propTypes = {
	children: PropTypes.any.isRequired,
};

export const FileListItemOptionBox = ({
	children,
	disabled = false,
	...props
}: {
	disabled?: boolean,
	children?: Node,
}) =>
	<div
		{...props}
		className={classNames('FileList__Item__Options__IconBox', {
			'FileList__Item__Options__IconBox--Disabled': disabled,
		})}
		onClick={!disabled ? props.onClick : () => {}}
	>
		{children}
	</div>;

FileListItemOptionBox.propTypes = {
	disabled: PropTypes.bool,
	children: PropTypes.any.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/FileList/FileListItem.js